
import React, { Component } from "react";
import { Radio  } from 'antd';
import '../css/widget/widget.radio.css';

class WidgetRadio extends Component {
    constructor (props) {
        super(props);

        this.state = {
        }
    }

    onChange = ( node ) => {
        this.setState({value:node.target.value});

        if( this.props.onChange )
        {
            this.props.onChange(node);
        }
    }

    render() {

        const {options=[], value } = this.props;

        return (
            <div className="sf-radio sd-radio sg-radio">
                <Radio.Group
                    name="radiogroup"
                    defaultValue={value}
                    value={value}
                    onChange={ this.onChange }
                    options={options}
                />
            </div>
        )
    }
}

export default WidgetRadio;